export const BASE_URL = 'https://www.thespeechclinic.ae';

/**
 * Approved DHA licence sentence for service pages.
 * Leave this empty until the clinic supplies the real wording.
 * Pages must render it only when it is a non-empty string.
 */
export const DHA_LICENCE_TEXT: string = '';

/** Stable entity id for Organization / LocalBusiness — use everywhere. */
export const ORGANIZATION_ID = `${BASE_URL}/#organization`;

/**
 * Single source of truth for NAP + local business identity.
 * Visible pages, geo meta, and JSON-LD must all derive from this.
 */
export const ORGANIZATION = {
  name: 'The Speech Clinic Dubai',
  alternateName: 'The Speech Clinic FZ LLC',
  url: BASE_URL,
  id: ORGANIZATION_ID,
  logo: `${BASE_URL}/logo.svg`,
  image: `${BASE_URL}/thumbnail.jpg`,
  telephone: '+971-508857146',
  /** Secondary landline shown on contact page only; primary NAP phone is telephone. */
  telephoneSecondary: '+971-44339891',
  email: 'info@thespeechclinic.ae',
  careersEmail: 'info@thespeechclinic.ae',
  /** Single-line street address for schema / structured use */
  streetAddress: 'Dubai Healthcare City, Building 47, Unit 301, 302, 303 & 304',
  address: {
    streetAddress: 'Dubai Healthcare City, Building 47, Unit 301, 302, 303 & 304',
    addressLocality: 'Dubai',
    addressRegion: 'Dubai',
    addressCountry: 'AE',
  },
  /** DHCC clinic pin (matches Google Maps embed / GBP) — not Dubai city center */
  geo: {
    latitude: 25.229031,
    longitude: 55.322413,
  },
  mapsUrl:
    'https://www.google.com/maps?ll=25.229031,55.322413&z=16&t=m&hl=en&gl=AE&mapclient=embed&cid=14517416241218903551',
  /** Matches contact page: Mon–Sat 9AM–7PM */
  openingHours: {
    dayOfWeek: [
      'Monday',
      'Tuesday',
      'Wednesday',
      'Thursday',
      'Friday',
      'Saturday',
    ] as const,
    opens: '09:00',
    closes: '19:00',
  },
  hoursDisplay: 'Mon - Sat (9AM - 7PM)',
  /** Multi-line display for footer / contact cards */
  addressLines: [
    'Dubai Healthcare City',
    'Building 47',
    'Unit 301, 302, 303 & 304',
  ] as const,
  sameAs: [
    'https://facebook.com/profile.php?id=100088752805760',
    'https://instagram.com/thespeechclinic_dubai',
    'https://www.linkedin.com/company/the-speech-clinic-dubai',
    'https://www.youtube.com/@thespeechclinic',
  ] as const,
} as const;

export const DEFAULT_VIDEO =
  'https://media.thespeechclinic.ae/website/videos/department%20video/ALL%20DEPARTMENTS%20COMBINED.mp4?v=2';

export const HERO_VIDEO = {
  name: 'About The Speech Clinic Dubai',
  description:
    'Discover The Speech Clinic Dubai — a leading pediatric therapy center in Dubai Healthcare City offering speech, occupational, physical, and ABA therapy for children.',
  contentUrl: 'https://media.thespeechclinic.ae/website/videos/hero-main.mp4',
  thumbnailUrl: `${BASE_URL}/thumbnail.jpg`,
  uploadDate: '2023-03-20T00:00:00+04:00',
  duration: 'PT2M23S',
} as const;
